import { OnlineStatusContext } from '@/contexts/onlineStatus';
import { useContext } from 'react';

export const useIsOnline = () => {
  const { isOnline, onlineStatus, checkOnlineStatus } = useContext(OnlineStatusContext);
  return { isOnline, onlineStatus, checkOnlineStatus };
};
